import React from 'react';
import KickImage from 'Reuseables/KickImage';

import { 
  Button
} from 'reactstrap';

import { CGContainer } from '../CommonGroundPage';

const SuccessPage = (props) => {
    return(
      <CGContainer
        textTop={props.textTop}
        textCenter={props.textCenter}
        textBottom={props.textBottom}
        img={props.img}
        textButton={props.textButton}
        onClick={props.onClick}
      />
    )
}

export default SuccessPage;